<template>
  <div >
    <!-- User image input -->
    <div class='h-20 grid grid-rows-3 justify-items-start'>
      <div class='pr-3'>Step 1: Load image and click 4 corners</div>
      <div class='py-4'><input type="file" id="file" :name="files" @change="newimg" accept="image/*"/></div>
      <div class='mt-4'><button class='underline text-sm text-blue-800 italic hover:bg-gray-200 ' @click="load_demo">(Load a sample image)</button></div>
    </div>
    <!-- Input image -->
    <div class='flex justify-around'>
        <div id='srcimgdiv' class='pr-6' v-cloak @drop.prevent="addFile"
             @dragover.prevent @dragenter.self="dragEnter" @dragleave.self="dragLeave">
            <canvas id="srcimg" ref="srcimg" class="imgcanvas"></canvas>
        </div>
    </div>

    <!-- Zoomed canvas -->
    <div class='grid  justify-items-start'>
        <div class='pr-3'>Step 2 (optional): Perform fine adjustment and set aspect ratio</div>
    </div>
    <div class='md:flex'>
        <div class='p-5'>
            <div><canvas id="zoom_TL" ref="zoom_TL" class="zoomedcanvas imgcanvas"></canvas></div>
            <div><canvas id="zoom_BL" ref="zoom_BL" class="zoomedcanvas imgcanvas"></canvas></div>
        </div>
        <div class='p-5'>
            <div><canvas id="zoom_TR" ref="zoom_TR" class="zoomedcanvas imgcanvas"></canvas></div>
            <div><canvas id="zoom_BR" ref="zoom_BR" class="zoomedcanvas imgcanvas"></canvas></div>
        </div>
    </div>
    <div class='grid justify-items-start'>
        <div>
            <input type="checkbox" id="checkbox" v-model="fixed_aspect_chkbox" v-on:change="update_aspect">
            <label class='px-3 text-lg' for="checkbox">Enforce fixed aspect ratio:</label>
            <input class='text-lg px-1' v-bind:disabled="!fixed_aspect_chkbox" v-model="fixed_aspect_value" placeholder="Width divide by height">
        </div>
        <!-- <div><p>Readback {{fixed_aspect_value}} and {{fixed_aspect_chkbox}}</p></div> -->
    </div>

    <!-- Output image -->
    <div class='grid  justify-items-start'>
        <div class='pr-3'>Step 3:</div>
        <div class='grid justify-items-start'><button class='text-md text-gray-800 bg-gray-200 hover:bg-gray-300
                                                        shadow-md
                                                         border border-gray-500 rounded px-2 disabled:text-gray-50'
                                                         v-bind:class="clicked_coords.length==4 ? '' : 'opacity-50 cursor-not-allowed'"
                                                         v-bind:disabled="clicked_coords.length!=4"
                                                         @click="start_correction">Undistorts the image</button></div>
        <div class='grid justify-items-start'><button class='text-md text-gray-800 bg-gray-200 hover:bg-gray-300
                                                        shadow-md
                                                         border border-gray-500 rounded px-2'
                                                         v-bind:class="dst_img_generated ? '' : 'opacity-50 cursor-not-allowed'"
                                                         v-bind:disabled="!dst_img_generated"
                                                         @click="download_img">Download result</button></div>
    </div>
    <div class='flex justify-around'>
        <div><canvas id="dstimg" ref="dstimg" class="imgcanvas"></canvas></div>
    </div>


        
    <!-- Hidden debuggs -->
    <hr/>
    <div class='hidden'>
        <img ref="img" class="img"/>
        <img ref="dst_img" class="img"/>
    </div>
    <img src="" ref="orig_size_img" id="orig_size_img" alt=""/>
</div>

  
</template>

<script>

export default {
  name: 'CVMain',
  props: {
    msg: String
  },
  data () {
    return {
    //   faceClass: null,
    //   eyeClass: null,
       fixed_aspect_chkbox:false,
       fixed_aspect_value:1,
       files: [],
       init_img_width: 1,
       init_img_height: 1,
       orig_canvas: null,
       dst_img_generated: false,
       clicked_coords: [],
       sorted_coords: {'BL':[0,0],'TL':[0,0],'BR':[0,0],'TR':[0,0],},
       zoomed_params: {'BL':null,'TL':null,'BR':null,'TR':null,},
    }
  },
  precreate () {
  },
  created () {
    //let info = this.cv.getBuildInformation()
    //console.log('main created', info, this.cv);
  },
  mounted () {
    //this.loadImg()
    // let src = this.$refs.srcimg
    // let ctx = src.getContext('2d')
    // let img = this.$refs.img //new Image()
    // img.onload = function() {
    //     console.log("Found image dimensions",img.height, img.width)
    //     src.height = img.height
    //     src.width = img.width
    //     ctx.drawImage(img, 0 ,0)
    // }
  },
  methods: {
    newimg(evt) {
      //console.log('newimg');
      let files = evt.target.files
      if (!files.length) return
      let imgurl = URL.createObjectURL(files[0])
      this.load_img_src(imgurl);
    },
    load_demo(evt) {
        console.log('Demo image loaded');
        this.load_img_src("/demo.jpg");
    },
    addFile(e) {
      //console.log('Handling add files',e);
      let droppedFiles = e.dataTransfer.files;
      if(!droppedFiles) return;
      if(droppedFiles.length>1) {
        console.log('User attempted to upload ' + String(droppedFiles.length) + ' files');
        return;
      }
      ([...droppedFiles]).forEach(f => {
        this.files.push(f);
      });
      let imgurl = URL.createObjectURL(droppedFiles[0])

        this.load_img_src(imgurl);

    //   let img = this.$refs.img
    //   img.src = imgurl;
    //   this.$refs.orig_size_img = imgurl;
      
    //   var img_temp = new Image();
    //   this.orig_canvas = document.createElement("canvas");
    //   var ctx = this.orig_canvas.getContext('2d');
    //   img_temp.onload = function() {ctx.drawImage(img_temp,0,0)};
    //   img_temp.src = URL.createObjectURL(droppedFiles[0]);
    //   console.log('Orig canvas',ctx);

    //   console.log('file asj5',droppedFiles[0]);
      //console.log(this.files);
    },
    async load_img_src(img_src) {
        //console.log('Loaded image url with length:',img_src.length);
        if (img_src.length<100) {
            //console.log('Running load_img_src',img_src);
        }

        let src = this.$refs.srcimg
        let ctx = src.getContext('2d')
        let img = this.$refs.img //new Image()
        this.clicked_coords = [];

        let hidden_img = new Image();
        

        hidden_img.src = img_src;
        //console.log("before promise",hidden_img.height, hidden_img.width) // This will read 0,0. We have to wait for the image to load.
        await hidden_img.decode();
        //console.log("after promise",hidden_img.height, hidden_img.width)
        this.orig_canvas = document.createElement("canvas");
        let hidden_ctx = this.orig_canvas.getContext('2d');
        hidden_ctx.canvas.width = hidden_img.width;
        hidden_ctx.canvas.height = hidden_img.height;
        hidden_ctx.drawImage(hidden_img, 0 ,0)

        ctx.canvas.width = hidden_img.width;
        ctx.canvas.height = hidden_img.height;
        ctx.drawImage(hidden_img,0,0,ctx.canvas.width,ctx.canvas.height)
        
        // console.log("Found new image dimensions",hidden_img.height, hidden_img.width)
        // console.log("Found new image dimensions",img.naturalHeight, img.naturalWidth)

        //this.$refs.img.src = img_src;
        img.src = hidden_img.src;

        let clicked_coords = this.clicked_coords;
        let this_app = this;
        ctx.canvas.addEventListener('mousedown', function(e) {
            let canvas = document.getElementById('srcimg');
            const rect = canvas.getBoundingClientRect()
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            const img_x = Math.floor(x/rect.width*canvas.width);
            const img_y = Math.floor(y/rect.height*canvas.height);
            // console.log("User clicked canvas x: " + x + " y: " + y + " img_x: " + img_x + " img_y: " + img_y);
            //console.log('User clicked on main cavnas. Before clicked_coords:',clicked_coords);
            clicked_coords.push([img_x,img_y]);
            //console.log('After push',clicked_coords);
            if (clicked_coords.length > 4) {clicked_coords.shift()}
            //console.log('After shift:',clicked_coords);

            this_app.redraw_canvases();

            
        })
    },
    redraw_canvases() {
        let src = this.$refs.srcimg
        let ctx = src.getContext('2d')
        let this_app = this;
        let clicked_coords = this.clicked_coords;

        var dst_img_dataurl = this.orig_canvas.toDataURL("image/png");
        let hidden_img = new Image();
        hidden_img.src = dst_img_dataurl;

        ctx.drawImage(hidden_img,0,0,ctx.canvas.width,ctx.canvas.height);

        clicked_coords.forEach(coord => {
            ctx.moveTo(coord[0], coord[1]);
            ctx.beginPath();
            ctx.arc(coord[0], coord[1], Math.floor(0.02 * ctx.canvas.width), 0, Math.PI * 2, true);
            ctx.lineWidth = Math.floor(0.005 * ctx.canvas.width);
            ctx.strokeStyle = '#aa0000';
            ctx.stroke();
        })

        if (clicked_coords.length == 4) {
            this_app.sort_points();
            //console.log('4 clicks done.');
            ['BL','TL','BR','TR'].forEach((corner_ident) => {
                //console.log('Producing zoom for ',corner_ident)
                let src = this_app.cv.imread("srcimg");
                //let src = this_app.cv.imread(this_app.orig_canvas);
                let dst = new this_app.cv.Mat();
                
                let ctx_corner = document.getElementById("zoom_" + corner_ident).getContext('2d');
                let half_width = hidden_img.width * 0.1;
                let half_height = hidden_img.height * 0.1;
                ctx_corner.canvas.width = half_width*2;
                ctx_corner.canvas.height = half_height*2;

                let center_x = this_app.sorted_coords[corner_ident][0];
                let center_y = this_app.sorted_coords[corner_ident][1];
                center_x = Math.min(Math.max(half_width,center_x),src.cols-half_width);
                center_y = Math.min(Math.max(half_height,center_y),src.rows-half_height);
                this_app.zoomed_params[corner_ident] = {'center_x':center_x,'center_y':center_y,'half_width':half_width,'half_height':half_height};
                //console.log('ROI are',center_x-half_width, center_y-half_height, center_x+half_width, center_y+half_height);
                //console.log(src);
                // You can try more different parameters
                let rect = new this_app.cv.Rect(center_x-half_width, center_y-half_height, 2*half_width, 2*half_height);
                //let rect = new this_app.cv.Rect(10,10,600,460);
                dst = src.roi(rect);
                this_app.cv.imshow("zoom_"+corner_ident, dst);

                ctx_corner.canvas.addEventListener('mousedown', function(e) {
                    e.stopImmediatePropagation();
                    // The user clicked the zoomed image
                    const rect = ctx_corner.canvas.getBoundingClientRect();
                    const x = e.clientX - rect.left;
                    const y = e.clientY - rect.top;
                    
                    const img_x = Math.floor(x/rect.width*ctx_corner.canvas.width - this_app.zoomed_params[corner_ident]['half_width'] + this_app.zoomed_params[corner_ident]['center_x']);
                    const img_y = Math.floor(y/rect.height*ctx_corner.canvas.height - this_app.zoomed_params[corner_ident]['half_height'] + this_app.zoomed_params[corner_ident]['center_y']);
                    
                    //console.log("User clicked zoomed canvas "+corner_ident+" x: " + x + " y: " + y + " img_x: " + img_x + " img_y: " + img_y);
                    //clicked_coords.push([img_x,img_y]);
                    //if (clicked_coords.length > 4) {clicked_coords.shift()}
                    //console.log('Old coords are',this_app.clicked_coords);
                    //console.log({...this_app.sorted_coords, corner_ident:[img_x,img_y]})
                    this_app.sorted_coords[corner_ident] = [img_x,img_y];
                    // this_app.clicked_coords = [this_app.sorted_coords.BL,this_app.sorted_coords.TL,this_app.sorted_coords.BR,this_app.sorted_coords.TR];
                    this_app.clicked_coords.shift();
                    this_app.clicked_coords.shift();
                    this_app.clicked_coords.shift();
                    this_app.clicked_coords.shift();
                    this_app.clicked_coords.push(this_app.sorted_coords.BL);
                    this_app.clicked_coords.push(this_app.sorted_coords.TL);
                    this_app.clicked_coords.push(this_app.sorted_coords.BR);
                    this_app.clicked_coords.push(this_app.sorted_coords.TR);
                    //console.log('New coords are now',this_app.clicked_coords);
                    
                    this_app.redraw_canvases();
                })

                //console.log('Success producing zoom for ',corner_ident)
                //ctx_corner.drawImage(dst,0,0,ctx_corner.canvas.width,ctx_corner.canvas.height);    
                // ctx_corner.drawImage(hidden_img,0,0,ctx_corner.canvas.width,ctx_corner.canvas.height);    
                //this.cv.imshow(this.$refs.zoom_TL, gray)
            });
        }
    },
    update_aspect() {
        if (this.fixed_aspect_chkbox) {
            return; // Then we don't update the aspect ratio
        }
        if (this.clicked_coords.length != 4) {
            this.fixed_aspect_value = 1;
        } else {
            let x_min = 0.5*(this.sorted_coords.BL[0] + this.sorted_coords.TL[0]);
            let x_max = 0.5*(this.sorted_coords.BR[0] + this.sorted_coords.TR[0]);
            let y_min = 0.5*(this.sorted_coords.TL[1] + this.sorted_coords.TR[1]);
            let y_max = 0.5*(this.sorted_coords.BL[1] + this.sorted_coords.BR[1]);
            this.fixed_aspect_value = (x_max-x_min)/(y_max-y_min);
            this.$forceUpdate();
        }
        
    },
    dragEnter(event) {
        //if ( event.target.className == "droptarget" ) {
            document.getElementById("srcimgdiv").classList.add('activedrag');
            console.log('trigger dragenter');
        //}
    },
    dragLeave(event) {
        //if ( event.target.className == "droptarget" ) {
            document.getElementById("srcimgdiv").classList.remove('activedrag');
            event.target.style.border = "";
        //}
        console.log('trigger dragLeave');
    },
    start_correction(evt) {
      //console.log('Click activated');
      this.do_perspective_transform();
      return;

    },
    calculateArea(coords) {
        let area = 0;

        for (let i = 0; i < coords.length; i++) {
        const [x1, y1] = coords[i];
        const [x2, y2] = coords[(i + 1) % coords.length];

        area += x1 * y2 - x2 * y1
        }
        return area / 2;
    },
    sort_points() {
        // This attempts to figure out which are the four corners for the clicked points
        if (this.clicked_coords.length != 4) return;
        let trial_indices = [[0,1,2,3],[0,1,3,2],[0,2,1,3],[0,2,3,1],[0,3,1,2],[0,3,2,1]];
        let areas = trial_indices.map(indices => this.calculateArea(indices.map(x => this.clicked_coords[x])));
        
        var indexOfMaxValue = areas.reduce((iMax, x, i, arr) => x > arr[iMax] ? i : iMax, 0);
        var clockwise_indices_seq = trial_indices[indexOfMaxValue];
        //console.log(areas,indexOfMaxValue,clockwise_indices_seq);

        var sorting_by_leftmost = Array.from(Array(4).keys()).sort((a, b) => this.clicked_coords[a][0] < this.clicked_coords[b][0] ? -1 : (this.clicked_coords[b][0] < this.clicked_coords[a][0]) | 0);
        if (this.clicked_coords[sorting_by_leftmost[0]][1] < this.clicked_coords[sorting_by_leftmost[1]][1]) {
            this.sorted_coords.TL = this.clicked_coords[sorting_by_leftmost[0]];
            this.sorted_coords.BL = this.clicked_coords[sorting_by_leftmost[1]];
        } else {
            this.sorted_coords.BL = this.clicked_coords[sorting_by_leftmost[0]];
            this.sorted_coords.TL = this.clicked_coords[sorting_by_leftmost[1]];
        }
        if (this.clicked_coords[sorting_by_leftmost[2]][1] < this.clicked_coords[sorting_by_leftmost[3]][1]) {
            this.sorted_coords.TR = this.clicked_coords[sorting_by_leftmost[2]];
            this.sorted_coords.BR = this.clicked_coords[sorting_by_leftmost[3]];
        } else {
            this.sorted_coords.BR = this.clicked_coords[sorting_by_leftmost[2]];
            this.sorted_coords.TR = this.clicked_coords[sorting_by_leftmost[3]];
        }
        this.update_aspect();
        //console.log(this.sorted_coords);


    //   let flatten_coords = this.clicked_coords.flat();
    //    clicked_coords: [],
    //    sorted_coords: {'BL':[0,0],'TL':[0,0],'BR':[0,0],'TR':[0,0],},

    },
    do_perspective_transform() {
        this.sort_points();


        // let src = this.cv.imread(this.$refs.srcimg);
        let src = this.cv.imread(this.orig_canvas);
        //this.orig_canvas.getContext('2d')

        let dst = new this.cv.Mat();
        let dsize = new this.cv.Size(src.cols, src.rows);
        console.log('dsize is',dsize);
        // (data32F[0], data32F[1]) is the first point
        // (data32F[2], data32F[3]) is the sescond point
        // (data32F[4], data32F[5]) is the third point
        // (data32F[6], data32F[7]) is the fourth point
        let srcTri = this.cv.matFromArray(4, 1, this.cv.CV_32FC2, ['TL','TR','BL','BR'].map(x => this.sorted_coords[x]).flat()); // [x1,y1,x2,y2,x3,y3,x4,y4]
        let x_min = 0.5*(this.sorted_coords.BL[0] + this.sorted_coords.TL[0]);
        let x_max = 0.5*(this.sorted_coords.BR[0] + this.sorted_coords.TR[0]);
        let y_min = 0.5*(this.sorted_coords.TL[1] + this.sorted_coords.TR[1]);
        let y_max = 0.5*(this.sorted_coords.BL[1] + this.sorted_coords.BR[1]);
        // console.log('Mapping from', ['TL','TR','BL','BR'].map(x => this.sorted_coords[x]).flat())
        // console.log('Mapping to',[x_min, y_min, x_max, y_min, x_min, y_max, x_max, y_max]);
        if (this.fixed_aspect_chkbox) {
            y_max = y_min + (x_max-x_min)/this.fixed_aspect_value;
        }
        let dstTri = this.cv.matFromArray(4, 1, this.cv.CV_32FC2, [x_min, y_min, x_max, y_min, x_min, y_max, x_max, y_max]);
        let M = this.cv.getPerspectiveTransform(srcTri, dstTri);
        // You can try more different parameters
        this.cv.warpPerspective(src, dst, M, dsize, this.cv.INTER_LINEAR, this.cv.BORDER_CONSTANT, new this.cv.Scalar());
        this.cv.imshow(this.$refs.dstimg, dst);
        var canvas = document.getElementById("dstimg");
        var dst_img_dataurl = canvas.toDataURL("image/png");
        this.$refs.dst_img.src = dst_img_dataurl;
        this.dst_img_generated = true;
        src.delete(); dst.delete(); M.delete(); srcTri.delete(); dstTri.delete();

    },
    download_img() {
        let a = document.createElement("a");
        a.href = this.$refs.dst_img.src
        a.download = "download";
        a.click();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.imgcanvas {
    /* visibility: hidden; */
   max-width: 100%;
  /* max-height: 500px; */

width:1200px;
  border: 2px solid #000;
  margin: 10px;
}
.img {
  /* visibility: hidden; */
    /* max-width: 100%; */
  /* max-height: 500px; */
}
.activedrag {
    shadow: 2px 2px 5px red;
    border:2px solid red;
}
#orig_size_img {
    float: left;
    position: absolute;
left: 0;
    visibility: hidden;
    object-fit: none; 
}

#file {
  float: left;
}
</style>